export default __webpack_public_path__ + "static/media/glenn_begley.2b2d1599.jpg";